export const objectToQueryParams = (params: Record<string, any>): string => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        queryParams.append(key, item.toString());
      });
    } else {
      queryParams.append(key, value.toString());
    }
  });

  return `?${queryParams.toString()}`;
};
